import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { TaskDetailPage } from "@client/components/settings/job-manager/task/task-detail-page";

function isValidDetailTab(v: unknown): v is "detail" | "logs" {
  return v === "detail" || v === "logs";
}

export const Route = createFileRoute(
  "/_app/settings/job-manager/schedule/$scheduleId/$taskId",
)({
  validateSearch: (search: Record<string, unknown>) => ({
    tab: isValidDetailTab(search.tab) ? search.tab : "detail",
  }),
  component: RouteComponent,
});

function RouteComponent() {
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: "/settings/job-manager/schedule/$scheduleId/$taskId" });
  return (
    <TaskDetailPage
      activeTab={tab}
      onTabChange={(t) => {
        if (t === "detail" || t === "logs") {
          navigate({ search: { tab: t }, replace: true });
        }
      }}
    />
  );
}
